import { render, staticRenderFns } from "./Sjzx.vue?vue&type=template&id=5faadcae&scoped=true&"
import script from "./Sjzx.vue?vue&type=script&lang=js&"
export * from "./Sjzx.vue?vue&type=script&lang=js&"
import style0 from "./Sjzx.vue?vue&type=style&index=0&id=5faadcae&rel=stylesheet%2Fless&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faadcae",
  null
  
)

export default component.exports